import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getProxyPerformanceMetrics;

export type ProxyPerformanceMetricsResponse = ApiResponse<typeof apiFn>;

const PROXY_PERFORMANCE_METRICS_QUERY_KEY = 'dbo-proxy-performance-metrics';

const getProxyPerformanceMetricsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [PROXY_PERFORMANCE_METRICS_QUERY_KEY, params] as const;

export const useProxyPerformanceMetricsQuery = <
  SELECT = ProxyPerformanceMetricsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<ProxyPerformanceMetricsResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getProxyPerformanceMetricsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
